import { CSS_EASE_IN_OUT, CSS_EASE_OUT, DURATION } from '../../../lib/motion';

// ── Motion constants ────────────────────────────────────────────────────────────
// How far the screen *behind* the one sliding away is shifted left while it's
// covered — the iOS "parallax" peek (the destination drifts in from a head-start
// rather than starting full off-screen, so a back-swipe reveals it immediately).
export const PARALLAX = 0.22;
// Black scrim laid over that underlying screen while it's covered, fading to 0 as
// it's revealed (so a covered screen reads as "dimmed underneath", not flat).
export const DIM_MAX = 0.14;
// Push/pop slide + cross-fade durations (ms). Sourced from lib/motion's one scale
// so a button-back and a swipe-back resolve to the same page timing.
export const SLIDE_MS = DURATION.page;
export const FADE_MS = DURATION.small;
// Interactive edge-swipe-back tuning (was useEdgeSwipeBack — folded in here so the
// gesture and the declarative transition share one layer model and never double-
// animate the same pop).
export const EDGE_ZONE_PX = 28;
export const DIRECTION_LOCK_PX = 10;
export const COMMIT_DISTANCE_RATIO = 0.42;
export const MIN_FLICK_PX = 56;
export const FLICK_VELOCITY = 0.35;
// Baselines for the swipe settle; the actual duration is scaled by the distance
// still to travel + the release velocity (see useEdgeSwipeBack) so a near-complete
// swipe doesn't crawl the last few pixels and a flick lands fast.
export const POP_MS = DURATION.page;
export const CANCEL_MS = DURATION.cancel;
export const POP_MIN_MS = 160;
export const CANCEL_MIN_MS = 120;
// Safety net if a `transitionend` is ever missed (e.g. a 0ms reduced-motion settle).
export const SETTLE_GUARD_MS = 90;
export const SHADOW = '-12px 0 30px rgba(0,0,0,0.18)';

export const CB_IOS = CSS_EASE_IN_OUT;
export const CB_OUT_IOS = CSS_EASE_OUT;

/** react-router stores a monotonically increasing history index on history.state. */
export function historyIdx(): number {
  return (window.history.state as { idx?: number } | null)?.idx ?? 0;
}
